import { createContext, useCallback, useContext, useEffect, useState } from "react";

const AssistantContext = createContext(null);

export function AssistantProvider({ children }) {
    const [course, setCourse] = useState(null);
    const [open, setOpen] = useState(false);
    const [teacherIntent, setTeacherIntent] = useState(false);
    const [prefill, setPrefill] = useState("");
    const [activity, setActivity] = useState(null);

    const openAssistant = useCallback((opts = {}) => {
        setTeacherIntent(!!opts.teacher);
        setPrefill(opts.prefill || "");
        setOpen(true);
    }, []);

    return (
        <AssistantContext.Provider value={{ course, setCourse, open, setOpen, teacherIntent, setTeacherIntent, openAssistant, prefill, setPrefill, activity, setActivity }}>
            {children}
        </AssistantContext.Provider>
    );
}

export function useAssistant() {
    return useContext(AssistantContext);
}

export function useCourseAssistant(ctx) {
    const { setCourse } = useAssistant();
    const key = ctx ? `${ctx.type}:${ctx.id}` : null;
    useEffect(() => {
        if (!ctx?.id) return undefined;
        setCourse({ type: ctx.type, id: ctx.id, title: ctx.title });
        return () => setCourse(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, ctx?.title]);
}
